import { render, staticRenderFns } from "./gestor_landingpage.vue?vue&type=template&id=4072c898&scoped=true"
import script from "./gestor_landingpage.js?vue&type=script&lang=js&external"
export * from "./gestor_landingpage.js?vue&type=script&lang=js&external"
import style0 from "./gestor_landingpage.scss?vue&type=style&index=0&id=4072c898&prod&lang=scss&scoped=true&external"
import style1 from "./gestor_landingpage.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4072c898",
  null
  
)

export default component.exports